import { useMutation, type UseMutationResult } from '@tanstack/react-query'
import type { ChangePasswordInput } from '@lib/input/auth.input'
import { authService } from '@/services/AuthService'
import type { User } from '@/schemas/auth.schema'

/**
 * Change the signed-in user's password.
 *
 * Nothing is invalidated on success. The password is not part of any cached
 * query, the identity behind it has not changed, and the token keeps working —
 * so there is nothing stale to refetch.
 */
export function useChangePassword(): UseMutationResult<
  User,
  Error,
  ChangePasswordInput
> {
  return useMutation({
    mutationFn: (input: ChangePasswordInput) =>
      authService.changePassword(input),
  })
}
